/**
 * Reductor de REDUX para controlar los estados del componente de Login
 */

import { AUTH } from '../../application/types';
import { Map } from 'immutable';

/**
 * Exporta el reductor authenticate
 * @param {object} state 
 * @param {object} action 
 */
export const authenticate = ( state = Map({ type: AUTH.LOGGINGIN, isLoggedIn: false }), action ) => {

  switch ( action.type ) {

    case AUTH.LOGGINGIN:
      return state.set('login', {
        type: action.type,
        isLoggedIn: false
      });
    
    case AUTH.LOGGEDIN:
      return state.set('login', {
        type: action.type,
        isLoggedIn: true,
        user: action.user
      });
  
    case AUTH.CANCELED:
      return state.set('login', {
        type: action.type,
        isLoggedIn: false
      });

    case AUTH.LOGGINGOUT:
      return state.set('login', {
        type: action.type,
        isLoggedOut: false,
      });

    case AUTH.LOGGEDOUT:
      return state.set('login', {
        type: action.type,
        isLoggedOut: true
      });

    // El resolver de MFA nativo NO es serializable: vive en el singleton
    // application/lib/mfa_resolver.js. Aquí solo van los hints legibles.
    case AUTH.MFA_TOTP_REQUIRED:
      return state.set('login', {
        type: action.type,
        isLoggedIn: false,
        hints: action.hints || []
      });

    case AUTH.MFA_REQUIRED:
      return state.set('login', {
        type: action.type,
        isLoggedIn: false
      });

    case AUTH.MFA_ENROLL_REQUIRED:
      return state.set('login', {
        type: action.type,
        isLoggedIn: false
      });

    case AUTH.ERROR:
      return state.set('login', {
        type: action.type,
        code: action.code,
        message: action.message
      });

    default:
      return state;

  }

}